<template>
    <div class="login-signup-section" style="z-index: 8;">
        <div class="header-logo">
            <router-link :to="{ path: '/apps'}">
                <img src="/assets/img/logo.svg" alt="" width="232">
            </router-link>
        </div>
        <div class="login-left-part d-md-flex align-items-center">
            <div class="form-part">
                <h1>Forgot password</h1>
                <ValidationObserver ref="form" v-slot="{ invalid }">
                    <b-form v-on:submit.prevent="getResetToken">
                        <div horizontal class="form-group">
                            <ValidationProvider placeholder="Email address..."
                                                name="Email"
                                                rules="required|email"
                                                v-slot="{ errors }">
                                <b-form-input id="email"
                                              type="text"
                                              class="form-control"
                                              placeholder="Email address..."
                                              v-model="form.email"/>
                                <div class="field-check" v-if="form.email && errors.length < 1"></div>
                                <template v-if="errors.length > 0">
                                    <b-form-row class="text-danger">
                                        <i class="fa fa-warning"></i>
                                        <span class="help invalid-feedback">
                                        {{ errors[0] }}
                                    </span>
                                    </b-form-row>
                                </template>
                            </ValidationProvider>
                        </div>
                        <p class="send-email-text">We’ll send you an email to reset your password soon</p>

                        <b-form-group class="form-group form-btn">
                            <b-button :disabled="invalid"
                                      type="submit"
                                      :class="{ 'confirm-btn confirmed' : successMessage }"
                                      variant="primary">{{ btnTx }}</b-button>
                        </b-form-group>
                        <p class="signing-text">Go back to <router-link :to="{ path: 'login'}">Sign In</router-link></p>

                    </b-form>
                </ValidationObserver>
            </div>
        </div>
        <div class="login-right-part">
            <div class="login-right-logo">
                <img src="assets/img/right-logo.svg" alt="">
            </div>
        </div>

    </div>

</template>

<script>
import {mapGetters} from 'vuex';
import {ValidationObserver, ValidationProvider} from "vee-validate";

export default {
    name: "ForgotPassword",
    components: {
        ValidationObserver,
        ValidationProvider,
    },
    data() {
        return {
            errorMessage: "",
            successMessage: "",
            text: "success",
            errors: [],
            form: {
                email: '',
            },
            btnTx: 'Confirm',
        }
    },
    methods: {
        getResetToken() {
            this.btnTx = 'Confirming...'
            this.$store
                .dispatch("forget", this.form)
                .then((res) => {
                    this.successMessage = 'email sent';
                }).catch(({data}) => {
                this.errors = data.errors;
            });
        }
    }
}
</script>

<style scoped>

</style>
